export const FETCH_TABLES_START = 'table/FETCH_TABLES_START';
export const FETCH_TABLES_SUCCESS = 'table/FETCH_TABLES_SUCCESS';
export const FETCH_TABLES_FAILURE = 'table/FETCH_TABLES_FAILURE';

export const SET_TABLES = 'table/SET_TABLES';
